import { Http } from "../Http";
import { AxiosPromise } from "axios";
import { getUserAccessToken } from "../selectors/Accounts";

export default class TestimonialService {
	public static testimonialGetByFilter(input: any) {
		return Http.axios()
			.post(`/api/Messages/getallvideohotline`, input, {
				headers: { Authorization: getUserAccessToken() },
			})
			.catch((e: { response: any }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static testimonialGetDetail(id: any) {
		return Http.axios()
			.get(`/api/Messages/getvideohotlinebyid/${id}`, {
				headers: { Authorization: getUserAccessToken() },
			})
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static testimonialStatusUpdate(input: any) {
		return Http.axios()
			.post("/api/Messages/UpdateVideoApproval", input, {
				headers: { Authorization: getUserAccessToken() },
			})
			.then((res: any) => {
				return res;
			})
			.catch((e: any) => {
				return e.response;
			}) as AxiosPromise<any>;;
	}

	public static testimonialVideoStatusUpdate(input: any) {
		return Http.axios()
			.post("/api/Messages/update-message-video-active", input, {
				headers: { Authorization: getUserAccessToken() },
			})
			.then((res: any) => {
				return res;
			})
			.catch((e: any) => {
				return e.response;
			}) as AxiosPromise<any>;;
	}
}
